import { useQuery } from 'react-query';
import { getInvoice, getInvoiceQueryKey, invoiceCacheOptions } from '@frontend/api-invoices';

export const useInvoiceQuery = (invoiceId: string | null, locationIds: string[]) => {
  const queryKey = getInvoiceQueryKey(invoiceId!);

  const { isLoading, isError, data, isFetched, isRefetching, isFetching, refetch } = useQuery({
    queryKey,
    queryFn: () => getInvoice(invoiceId!, locationIds),
    enabled: !!invoiceId,
    ...invoiceCacheOptions,
    retry: 3,
    retryDelay: 1000,
  });

  return {
    invoice: data,
    isLoading,
    isError,
    isFetched,
    refetch,
    queryKey,
    isRefetching,
    isFetching,
  };
};
